import { Text, Link, Box } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';

const WarmUp = ({ movements }) =>
(
    <>
    <Text fontSize="lg" fontFamily="Museo Sans Bold">Warm Up</Text>
    {
        movements && movements.map(movement => (
            <Link href={movement.link} isExternal key={movement.name}>
            <Box mx="20px" mt="-5px">
            {movement.name} <ExternalLinkIcon mx="2px" />
            </Box>
            </Link>
        ))
    }
    </>
);

export default WarmUp;